module.exports = function(comments) {
	'use strict';
	comments.directive('searchComments',searchComments);
	searchComments.$inject=["cyrilicToLatin","config","highlightWords",'$http','API_URL','getDataService','$rootScope','refreshtokenService','serverError','postDataService','alertService', 'offlineError'];
	function searchComments(cyrilicToLatin,config,highlightWords,$http,API_URL,getDataService,$rootScope,refreshtokenService,serverError,postDataService,alertService, offlineError) {
		return {
			restrict: 'E',
			scope: {
		      obj:"="
		    },
		 	template: require('./partial/search-comments.html'),
		    link: function (scope, element, attrs) {
				var state = 'comments';
				scope.moderator_guide = '';
				if($rootScope.role_id == 'superadmin' || $rootScope.role_id == 'administrator') {
					scope.adminPermisions = true;
				}			
				if(scope.obj.serchCommentsModalShow) {
					scope.status='pending';
					var getCommentsFunction = function() {
						$rootScope.hasLoaded = false;
						scope.postComments = [];
		     			getDataService.get({
			              	param1:state,
			              	document_id:scope.obj.commentPostId,
			              	status: scope.status,
							type:(scope.obj.commentsType == 'video')? 'video':null
		              	}).$promise.then(function(data){
			                scope.postComments = data.comments;
							if(config.highlightWordsActive && config.highlightWordsDiacritics && config.highlightWordsDiacritics.length>0) {
								for(var i=0; i<scope.postComments.length;i++) {
									scope.postComments[i].data.comment_author = cyrilicToLatin(scope.postComments[i].data.comment_author) 
									scope.postComments[i].data.comment_author = highlightWords(scope.postComments[i].data.comment_author, config.highlightWordsDiacritics)
									scope.postComments[i].data.comment_content = cyrilicToLatin(scope.postComments[i].data.comment_content) 
									scope.postComments[i].data.comment_content = highlightWords(scope.postComments[i].data.comment_content, config.highlightWordsDiacritics)
								}
							}
							if(data.document) {
								scope.moderator_guide = data.document.moderator_guide
								scope.commentsPriority = data.document.comments_priority;
							}
			            	scope.emptyTable = false;
			              	$rootScope.hasLoaded = true;
		            	}, function(error){
				            if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								return
							}  
			                if(error.status ==401) {
			                	var promise = refreshtokenService.getAccessToken();
				                promise.then(
			                    function(answer) {
				                    if(answer==200) {
				                      getCommentsFunction();
				                    }
				                    // do something
				                },
				                function(error) {
				                },
				                function(progress) {
				                   // report progress
				                });
			              	} else if(error.status ==502) {
			                  serverError()
		                	} else if(error.status ==404) {
				                scope.emptyTable = true;
								scope.commentsPriority = null
				            } else {
				                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
				            }	   
			                $rootScope.hasLoaded = true;
				               
				      	});
					}
					getCommentsFunction();
					var putPostsFunction = function(url) {
				      var updateDataPosts = {
				        "ids": scope.checkedPostsforUpdate,
				      }
					  $rootScope.hasLoaded = false;
				      var putFunction = function() {
				        $http.put(url , updateDataPosts)
				        .success(function (data, status, headers) {
				            alertService('success','Success ', data.message, 500);
				            scope.checkedPostsforUpdate = [];
				            // scope.obj.tableParams.reload();
				            getCommentsFunction();
				        })
				        .error(function (data, status, header, config) {
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								scope.checkedPostsforUpdate = [];
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
				          	if(status ==401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
								function(answer) {
									if(answer==200) {   
									putFunction();
									}
								},
								function(error) {
									// report something
								},
								function(progress) {
								// report progress
								});
							}else if(status ==502) {
								serverError();
							} else {  
								alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
							
							}
							scope.checkedPostsforUpdate = [];
							$rootScope.hasLoaded = true;
				        });
				      }
				      putFunction();
				    }
				   
				    scope.updateStatusPost = function(post_id, status) {
				      scope.checkedPostsforUpdate = [];
					  if(scope.obj.commentsType =='video') {
						putPostsFunction(API_URL + 'comments/bulk/'+status + '?type=video');  
					  } else {
						putPostsFunction(API_URL + 'comments/bulk/'+status);
					  }
				      scope.checkedPostsforUpdate.push(post_id);
				    }
				    scope.changeStatus =function(event,activeStatus) {
			          scope.status = activeStatus;
			          getCommentsFunction();			         
			        }
				}
			}    
		}
	}
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/commentsModule/allcomments/js/directive/searchCommentsDirective.js
// module id = 495
// module chunks = 0